module.exports = __webpack_public_path__ + "img/d8fa81da17df4313c86e6b401b8ef198.a7a909a7.jpg";